import React from 'react';
import { a as _taggedTemplateLiteral } from './_rollupPluginBabelHelpers-53ddb3bb.js';
import styled from 'styled-components';
import { g as getRem } from './styled-utils-3f8463ca.js';

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  background: ", ";\n  border-radius: ", ";\n  display: inline-block;\n  height: ", ";\n  width: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StyledDot = styled.span(_templateObject(), function (_ref) {
  var color = _ref.color,
      theme = _ref.theme;
  return theme.colors[color][5];
}, function (_ref2) {
  var theme = _ref2.theme;
  return getRem(theme.radii.circle, theme.rootVal);
}, function (_ref3) {
  var size = _ref3.size,
      theme = _ref3.theme;
  return getRem(theme.space[size], theme.rootVal);
}, function (_ref4) {
  var size = _ref4.size,
      theme = _ref4.theme;
  return getRem(theme.space[size], theme.rootVal);
});

var Dot = function Dot(_ref5) {
  var color = _ref5.color,
      size = _ref5.size;
  return React.createElement(StyledDot, {
    color: color,
    size: size
  });
};

Dot.defaultProps = {
  size: 'sm',
  color: 'grey'
};
Dot.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Dot",
  "props": {
    "size": {
      "defaultValue": {
        "value": "'sm'",
        "computed": false
      },
      "type": {
        "name": "enum",
        "value": [{
          "value": "'xs'",
          "computed": false
        }, {
          "value": "'sm'",
          "computed": false
        }, {
          "value": "'md'",
          "computed": false
        }]
      },
      "required": false,
      "description": "The size of the Dot"
    },
    "color": {
      "defaultValue": {
        "value": "'grey'",
        "computed": false
      },
      "type": {
        "name": "enum",
        "value": [{
          "value": "'grey'",
          "computed": false
        }, {
          "value": "'primary'",
          "computed": false
        }, {
          "value": "'secondary'",
          "computed": false
        }, {
          "value": "'success'",
          "computed": false
        }, {
          "value": "'warning'",
          "computed": false
        }, {
          "value": "'error'",
          "computed": false
        }]
      },
      "required": false,
      "description": "The color to use for the Dot"
    }
  }
};
export default Dot;
export { Dot, StyledDot };